@if (isFileSupportedByViewer()) {
  <app-fullscreen
    class="document-preview"
    [ngClass]="mode()"
    [showDownloadBtn]="allowDownloadFile() && !isLoading()"
    [showFullScreenBtn]="showFullScreenBtn() && !isLoading()"
    [isDownloadLoading]="isDownloadLoading()"
    [template]="targetTmp"
    (downloadFile)="downloadFile()">
  </app-fullscreen>
} @else {
  <div class="d-flex flex-column align-items-center justify-content-center unsupported-template">
    <span class="unsupported-template__title">
      {{ 'COMMON.preview_not_available_for_file' | translate : { name: fileName() } }}
    </span>
    <button class="primary-button mt-2" mat-flat-button (click)="downloadFile()">
      {{ 'COMMON.download' | translate }}
    </button>
  </div>
}

<ng-template #targetTmp>
  @switch (mode()) {
    @case (modes.MODEL_VIEWER) {
      <app-google-model-viewer [src]="fileSrc()" (loaded)="loaded()"></app-google-model-viewer>
    }
    @case (modes.IMAGE_VIEWER) {
      <img class="document-preview__image" [src]="fileSrc()" alt="Image" (load)="loaded()">
    }
    @case (modes.VIDEO_VIEWER) {
      <lib-video
        class="document-preview__video"
        [src]="fileSrc()"
        (started)="logUserVideoActivity(activityTypes.USER_START_WATCHING_VIDEO)"
        (watched)="logUserVideoActivity(activityTypes.USER_WATCHED_VIDEO)"
        (videoCanPlay)="loaded()">
      </lib-video>
    }
    @case (modes.PDF_VIEWER) {
      <app-pdf-viewer
        [src]="fileSrc()"
        [watermarkEnabled]="watermarkEnabled()"
        [allowDownloadFile]="allowDownloadFile()"
        [forceFullScreen]="forceFullScreen()"
        [fileName]="fileName()"
        (unload)="startLoading()"
        (startLoading)="startLoading()"
        (loaded)="loaded()">
      </app-pdf-viewer>
    }
    @case (modes.OFFICE_VIEWER) {
      <ngx-doc-viewer
        [class.inside-dialog]="insideDialog()"
        [url]="fileSrc()"
        [viewer]="mode()"
        (loaded)="loaded()">
      </ngx-doc-viewer>
    }
    @case (modes.GOOGLE_VIEWER) {
      <ngx-doc-viewer
        [class.inside-dialog]="insideDialog()"
        [url]="fileSrc()"
        [viewer]="mode()"
        [googleCheckContentLoaded]="true"
        (loaded)="loaded()">
      </ngx-doc-viewer>
    }
  }

  @if (isLoading() && !insideDialog() && (mode() !== modes.PDF_VIEWER || pdfViewer?.showPdf)) {
    <div class="loader document-preview-loader"></div>
  }
</ng-template>
